import { TGlobalStores } from '@/editor/stores';
import { CommonController2d } from '../CommonController';
import { rayIntersect } from '../operateEntityController/rayIntersect';
import { calMousePosition } from '@/editor/utils';
import { isHoverAllowed, isSelectAllowed } from './utils';
import * as THREE from 'three';

type IIntersectedEntity = ReturnType<typeof rayIntersect.rayEntities>[number];

export class OperateLayoutController extends CommonController2d {
  private _mousePosition: THREE.Vector2 = new THREE.Vector2();
  private _intersectedEntity: IIntersectedEntity | null = null;
  private _previousHoverEntity: IIntersectedEntity | null = null;
  private _prevSelectedEntity: IIntersectedEntity | null = null;

  constructor(globalStores: TGlobalStores) {
    super(globalStores);
  }

  override init() {
    super.init();
  }

  private _updateHoverEntity() {
    if (this._intersectedEntity?.entityId !== this._previousHoverEntity?.entityId) {
      if (isHoverAllowed(this._intersectedEntity)) {
        this._gs.editorStateStore.setHoverEntity(this._intersectedEntity);
      } else {
        this._gs.editorStateStore.clearHoverEntity();
      }
    }
  }

  private _updateSelectedEntity() {
    if (this._intersectedEntity?.entityId !== this._prevSelectedEntity?.entityId) {
      if (isSelectAllowed(this._intersectedEntity)) {
        this._prevSelectedEntity = this._intersectedEntity;
        this._gs.editorStateStore.setSelected(this._intersectedEntity);
      }
    }
  }

  private _setIntersectedEntity(entity: IIntersectedEntity | null) {
    this._previousHoverEntity = this._intersectedEntity;
    this._intersectedEntity = entity;
  }

  private _intersectEntity = () => {
    const intersectedEntities = rayIntersect.rayEntities(this._mousePosition);

    if (intersectedEntities[0]) {
      this._setIntersectedEntity(intersectedEntities[0]);
    } else {
      this._setIntersectedEntity(null);
    }
  };

  protected override mouseUp = (e: MouseEvent) => {
    this._mousePosition = calMousePosition(e, this._domElement);
    this._intersectEntity();

    this._updateSelectedEntity();
  };

  protected override mouseDown = (e: MouseEvent) => {
    if (e.button !== 0) return;

    this._mousePosition = calMousePosition(e, this._domElement);
  };

  protected override mouseMove = (e: MouseEvent) => {
    this._mousePosition = calMousePosition(e, this._domElement);
    this._intersectEntity();
    this._updateHoverEntity();
  };

  override dispose() {
    super.dispose();
  }
}
